
export enum AwardDocumentDeliveryType {
    AdminsOnlyDocumentDownload,
    HtmlTemplate,
    DocumentDownload,
}